module.exports = __webpack_public_path__ + "img/img16.35db8017.png";